import React, { ReactElement } from 'react';

import s from './DescriptionImage.module.scss';
import TrackableLink from '../../TrackableLink';

interface DescriptionImageProps {
  src: string;
  alt: string;
  link: string;
  linkTitle: string;
  linkAriaLabel: string;
  descriptionTitle: string;
  description: string;
  tintColor?: string;
  textColor?: string;
  disableShadow?: boolean;
}

const DescriptionImage = (props: DescriptionImageProps): ReactElement => {
  const {
    src,
    alt,
    link,
    linkTitle,
    linkAriaLabel,
    descriptionTitle,
    description,
    tintColor,
    textColor,
    disableShadow,
  } = props;

  const tintStyle = {
    background: `linear-gradient(to bottom, ${tintColor}, ${tintColor})`,
  };
  const textStyle = {
    color: textColor,
  };
  return (
    <TrackableLink
      to={link}
      className={s.link}
      title={linkTitle}
      aria-label={linkAriaLabel}
    >
      <div
        className={s.wrapper}
        style={{
          WebkitBoxShadow: disableShadow ? 'none' : '0 0 5px 0 #b5b5b5',
        }}
      >
        <div className={s.imageContainer}>
          <img src={src} alt={alt} />
        </div>
        <div className={s.background} />
        <div className={s.backgroundBefore} style={tintStyle} />
        <div className={s.backgroundAfter} style={tintStyle} />
        <div className={s.contentContainer}>
          <div className={s.content}>
            <h2 className={s.title} style={textStyle}>
              <strong>{descriptionTitle}</strong>
            </h2>
            <div className={s.description} style={textStyle}>
              <p>{description}</p>
            </div>
          </div>
        </div>
      </div>
    </TrackableLink>
  );
};

DescriptionImage.defaultProps = {
  tintColor: '#f2f2f0',
  textColor: '#423b38',
  disableShadow: false,
};

export default DescriptionImage;
